import React from 'react';
import { Link } from 'react-router-dom';
import { BuyerSidebar } from '../Common/BuyerSidebar';
import Request from '../../Models/Request';

import { Header, Footer } from '../Common';
import { SideBar } from '../Common/SideBar';
import { AffiliatorSidebar } from '../Common/AffiliatorSidebar';
import {Spinner } from 'reactstrap';
// import { connect } from 'react-redux';
// import { buyerLogin } from '../../../Action/login';

class RequestDetailsBuyerEstimation extends React.Component {
    constructor(props) {
        super(props);
        if (localStorage.getItem('info') === null || localStorage.getItem('info') === '') {
            window.location.href = '/login';
        };
        this.state = {
            minHeight: "475px",
            RequestList: [],
            requestdetails: [],
            request: [],
            requestAll: [],
            existing: [],
            count: '',
            accepted: '',
            requestImage: '',
            sellerResponse: '',
            acceptedName: '',
            body: '',
            ready: 0
        };
        var logged_user = JSON.parse(window.localStorage.getItem('info'));
        var id = logged_user.id;
        this.getResponseAll();
        // this.getResponseDetails();
    }
    componentDidMount() {
        window.scrollTo(0, 0)
        setTimeout(
            function() {
                this.setState({ready: 1});
            }
            .bind(this),
            1000
        );
    }
    getResponseAll() {
        Request.getRequestResponse(this.props.location.state.id).then(res => {
            this.setState({ acceptedName: res.data.response.first_name })
            this.setState({ body: res.data.request.content })
            this.setState({ accepted: res.data.accepted_id })
            this.setState({
                sellerResponse: res.data.request.accepted_seller_id
            })
            if (res.data.response.length > 0) {
                this.setState({
                    requestImage: res.data.response[0].img_receiver
                })
            }
            this.getResponseDetails();
        })

    }
    getResponseDetails() {
        Request.getRequestDetail(this.props.location.state.id, this.state.sellerResponse).then(res => {
            if (res.data.payload != null) {
                this.setState({ requestdetails: res.data.payload })
                this.setState({ request: res.data.payload })
                this.setState({ requestAll: res.data.requestall })
                this.setState({ count: res.data.count })
                this.setState({ existing: res.data.existing_response })
            }
        })
    }
    updateField(type, e) {
        var obj = {};
        obj[type] = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        this.setState(obj);
    }

    handleSubmit(e) {
        // console.log('asd')
        e.preventDefault();
        let data = {
        }
        console.log(data);
    }

    Accept(a, b) {
        let data = {
            'request_id': a,
            'seller_id': b,
            'buyer_id': this.state.requestdetails.buyer_id
        }
        Request.acceptResponse(data).then(res => {
            if (res.data.status === 200) {
                alert('提案を受け取りました！')
                this.setState({ accepted: res.data.id })
            } else if (res.data.status === 10060) {
                alert('You have already accepted another proposal!');
                this.setState({ accepted: 0 })
            } else {
                alert('データを取得できませんでした！ 後で試してください');
                this.setState({ accepted: 0 })
            }
        })
            .catch(
                console.log('asd')
            )
    }

    sideBar() {
        var x = JSON.parse(localStorage.getItem('info'))
        if (x.user_type_id === 1) {
            return <BuyerSidebar />
        } else if (x.user_type_id === 2) {
            return <SideBar />
        } else if (x.user_type_id === 3) {
            return <AffiliatorSidebar />
        }
    }

    productsTitle() {
        if (this.state.requestdetails.product_id) {
            return (
                <Link to={{
                    pathname: `/categories-details/${this.state.requestdetails.product_id}`,
                    state: { id: this.state.requestdetails.product_id }
                }} className="col-md-12">
                    {this.state.requestdetails.pro_title}
                </Link>
            )
        } else {
            return (
                <div className=""></div>
            )
        }
    }

    render() {
        if (this.state.ready === 1) {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        //for mobile responsive
        if (isMobile) {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="container-fluid">
                        <div className="row">
                            {/* <div className="col-md-4 input_name">
                                {this.sideBar()}
                            </div> */}
                            <div className="col-md-8">
                                <div className="mt-5 mb-3 input_name big_font guide_text" style={{ width: "100%",fontSize:'20px' }}>
                                    詳細
                                    </div>
                                <div className="">
                                    <div className="card" style={{ width: "100%", backgroundColor: '#f4f2f0',fontSize:'13px' }}>
                                        <div className=" row card-body">
                                            <div className="col-md-12 ">
                                                <div className="row">
                                                    {this.productsTitle()}
                                                </div>
                                                <br />
                                                <div className="row">
                                                    <div className="col-md-3">相談依頼日</div>
                                                    <div className="col-md-1 small-hidden">:</div>
                                                    <div className="col-md-8"><b>{this.state.requestdetails.created_at}</b></div>
                                                </div>
                                                <br />
                                                <div className="row">
                                                    <div className="col-md-3">見積り提案期限</div>
                                                    <div className="col-md-1 small-hidden">:</div>
                                                    <div className="col-md-8"><b>{this.state.requestdetails.application_date}</b></div>
                                                </div>
                                                <br />
                                                <div className="row">
                                                    <div className="col-md-3">見積り予算</div>
                                                    <div className="col-md-1 small-hidden">:</div>
                                                    <div className="col-md-8"><b>{this.state.requestdetails.budget_range} 円</b></div>
                                                </div>
                                                <br />
                                                <div className="row">
                                                    <div className="col-md-3">サービス名</div>
                                                    <div className="col-md-1 small-hidden">:</div>
                                                    <div className="col-md-8"><b>{this.state.requestdetails.title}</b></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className=" row card-body">
                                            <div className="col-md-2"></div>
                                            <div className="col-md-12 card-text">
                                                {this.state.body.split('\n').map(function (item, key) {
                                                    return (
                                                        <span key={key}>
                                                            {item}
                                                            <br />
                                                        </span>
                                                    )
                                                })}
                                            </div>
                                        </div>
                                        <div>&nbsp;</div>
                                    </div>
                                    <div>&nbsp;</div>
                                    {(() => {
                                        if (this.state.existing.length === 0) {
                                            return (
                                                <div></div>
                                            )
                                        } else {
                                            return (
                                                <div className="card">
                                                    {this.state.existing.map(group =>
                                                        <div className="card-body" style={{ width: "100%", backgroundColor: '#f4f2f0' }}>
                                                            <div className="row">
                                                                <div className="">
                                                                </div>
                                                                <div className="col-md-10">
                                                                    <div className="" style={{ textAlign: "left" }}>
                                                                        <Link to={{ pathname: '/my-profile', state: { id: group.seller_id } }} style={{ textAlign: "left" }}>
                                                                            {group.seller}
                                                                        </Link>
                                                                    </div>
                                                                    <div style={{ textAlign: "left" }} className="mb-1">
                                                                        <span >見積価格: </span>{parseInt(group.estimated_price)}
                                                                    </div>
                                                                    <div style={{ textAlign: "left" }} className="mb-1">
                                                                        <span >完成予定日: </span>
                                                                        {(() => {
                                                                            if (group.estimated_deadline.length !== 0) {
                                                                                return (
                                                                                    <span>{group.estimated_deadline.substring(0, 11)}</span>
                                                                                )
                                                                            } else {
                                                                                return (
                                                                                    <span></span>
                                                                                )
                                                                            }
                                                                        })()}
                                                                    </div>
                                                                    <div style={{ textAlign: "left" }} className="mb-1">見積り詳細: &nbsp;
                                                                            {group.content.split('\n').map(function (item, key) {
                                                                        return (
                                                                            <span key={key}>
                                                                                {item}
                                                                                <br />
                                                                            </span>
                                                                        )
                                                                    })}
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-2">
                                                                    {(() => {
                                                                        if (group.status !== 'LAST') {
                                                                            return (
                                                                                <div></div>
                                                                            )
                                                                        } else {
                                                                            return (
                                                                                < Link to={{
                                                                                    pathname: `/payment`,
                                                                                    state: {
                                                                                        id: 0,
                                                                                        request_id: group.request_id,
                                                                                        seller_id: group.seller_id,
                                                                                        buyer_id: this.state.requestdetails.buyer_id,
                                                                                        estimated_price: group.estimated_price,
                                                                                        estimated_deadline: group.estimated_deadline,
                                                                                    }
                                                                                }}>
                                                                                    {(() => {
                                                                                        if (this.state.accepted === group.id && this.state.requestdetails.current_status !== 'UNDERESTIMATION') {
                                                                                            return (
                                                                                                <button style={{ padding: "12%", borderRdius: "8px", backgroundColor: "white", color: "red" }}>受け入れました</button>
                                                                                            )
                                                                                        } else {
                                                                                            return (
                                                                                                <button style={{ padding: "", width: '100px', backgroundColor: "#7ea9e6", borderColor: "#6290d1", height: '40px', borderRadius: '5px', color: '#fff', boxShadow: "#ffffff4d 0px 1px 0px 0px inset" }}>購入に進む</button>
                                                                                            )
                                                                                        }
                                                                                    })()}
                                                                                </Link>
                                                                            )
                                                                        }
                                                                    })()}

                                                                </div>
                                                            </div>
                                                            <hr />
                                                        </div>
                                                    )}
                                                </div>
                                            )
                                        }
                                    })()}
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            );
        }
        //for desktop view
        else if (isDesktop) {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container-fluid">
                        <div className="container">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-4 input_name">
                                        {this.sideBar()}
                                    </div>
                                    <div className="col-md-8">
                                        <div className="mt-5 mb-3 input_name big_font guide_text" style={{ width: "100%" }}>
                                            詳細
                                    </div>
                                        <div className="">
                                            <div className="card" style={{ width: "100%", backgroundColor: '#f4f2f0' }}>
                                                <div className=" row card-body">
                                                    {/* <div className="col-md-2" style={{ textAlign: "center" }}>
                                                    <img className="card-img-top" style={{ borderRadius: "50%", height: "60px" }} src={this.state.request.img} alt=""></img>&nbsp;&nbsp;
                                                    </div> */}
                                                    <div className="col-md-12 ">
                                                        <div className="row">
                                                            {this.productsTitle()}
                                                        </div>
                                                        <br />
                                                        <div className="row">
                                                            <div className="col-md-3">相談依頼日</div>
                                                            <div className="col-md-1">:</div>
                                                            <div className="col-md-8"><b>{this.state.requestdetails.created_at}</b></div>
                                                        </div>
                                                        <br />
                                                        <div className="row">
                                                            <div className="col-md-3">見積り提案期限</div>
                                                            <div className="col-md-1">:</div>
                                                            <div className="col-md-8"><b>{this.state.requestdetails.application_date}</b></div>
                                                        </div>
                                                        <br />
                                                        <div className="row">
                                                            <div className="col-md-3">見積り予算</div>
                                                            <div className="col-md-1">:</div>
                                                            <div className="col-md-8"><b>{this.state.requestdetails.budget_range} 円</b></div>
                                                        </div>
                                                        <br />
                                                        <div className="row">
                                                            <div className="col-md-3">サービス名</div>
                                                            <div className="col-md-1">:</div>
                                                            <div className="col-md-8"><b>{this.state.requestdetails.title}</b></div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className=" row card-body">
                                                    <div className="col-md-2"></div>
                                                    <div className="col-md-12 card-text">
                                                        {/* {this.state.requestdetails.content}<br /> */}
                                                        {this.state.body.split('\n').map(function (item, key) {
                                                            return (
                                                                <span key={key}>
                                                                    {item}
                                                                    <br />
                                                                </span>
                                                            )
                                                        })}
                                                    </div>
                                                </div>
                                                <div>&nbsp;</div>
                                                {/* <div className="card-body row" style={{ textAlign: "center", width: "100%" }}>
                                                <div className="col-md-4"></div>
                                                <div className="col-md-4">
                                                    {(() => {
                                                        if (this.state.requestdetails.current_status == 'UNDERESTIMATION') {
                                                            return (
                                                                <span style={{ fontSize: "15px" }}>相談中</span>
                                                            )
                                                        } else if (this.state.requestdetails.current_status == 'TRADING') {
                                                            return (
                                                                <span style={{ fontSize: "15px" }}>取引中</span>
                                                            )
                                                        } else if (this.state.requestdetails.current_status == 'CANCEL') {
                                                            return (
                                                                <span style={{ fontSize: "15px" }}>キャンセル</span>
                                                            )
                                                        } else if (this.state.requestdetails.current_status == 'COMPLETE') {
                                                            return (
                                                                <span style={{ fontSize: "15px" }}>取引完成</span>
                                                            )
                                                        }
                                                    })()}
                                                </div>
                                                <div className="col-md-4"></div>
                                            </div> */}
                                            </div>
                                            <div>&nbsp;</div>
                                            {(() => {
                                                if (this.state.existing.length === 0) {
                                                    return (
                                                        <div></div>
                                                    )
                                                } else {
                                                    return (
                                                        <div className="card">
                                                            {this.state.existing.map(group =>
                                                                <div className="card-body" style={{ width: "100%", backgroundColor: '#f4f2f0' }}>
                                                                    <div className="row">
                                                                        <div className="">
                                                                            {/* <img className="card-img-top" src={this.state.requestImage} style={{ width: "100%", height: "auto" }}></img> */}
                                                                        </div>
                                                                        <div className="col-md-10">
                                                                            <div className="" style={{ textAlign: "left" }}>
                                                                                <Link to={{ pathname: '/my-profile', state: { id: group.seller_id } }} style={{ textAlign: "left" }}>
                                                                                    {group.seller}
                                                                                </Link>
                                                                            </div>
                                                                            <div style={{ textAlign: "left" }} className="mb-1">
                                                                                <span >見積価格: </span>{parseInt(group.estimated_price)}
                                                                            </div>
                                                                            <div style={{ textAlign: "left" }} className="mb-1">
                                                                                <span >完成予定日: </span>
                                                                                {(() => {
                                                                                    if (group.estimated_deadline.length !== 0) {
                                                                                        return (
                                                                                            <span>{group.estimated_deadline.substring(0, 11)}</span>
                                                                                        )
                                                                                    } else {
                                                                                        return (
                                                                                            <span></span>
                                                                                        )
                                                                                    }
                                                                                })()}
                                                                            </div>
                                                                            <div style={{ textAlign: "left" }} className="mb-1">見積り詳細: &nbsp;
                                                                            {/* {group.content} */}
                                                                                {group.content.split('\n').map(function (item, key) {
                                                                                    return (
                                                                                        <span key={key}>
                                                                                            {item}
                                                                                            <br />
                                                                                        </span>
                                                                                    )
                                                                                })}
                                                                            </div>

                                                                        </div>
                                                                        <div className="col-md-2">
                                                                            {(() => {
                                                                                if (group.status !== 'LAST') {
                                                                                    return (
                                                                                        <div></div>
                                                                                    )
                                                                                } else {
                                                                                    return (
                                                                                        < Link to={{
                                                                                            pathname: `/payment`,
                                                                                            state: {
                                                                                                id: 0,
                                                                                                request_id: group.request_id,
                                                                                                seller_id: group.seller_id,
                                                                                                buyer_id: this.state.requestdetails.buyer_id,
                                                                                                estimated_price: group.estimated_price,
                                                                                                estimated_deadline: group.estimated_deadline,
                                                                                            }
                                                                                        }}>
                                                                                            {(() => {
                                                                                                if (this.state.accepted === group.id && this.state.requestdetails.current_status !== 'UNDERESTIMATION') {
                                                                                                    return (
                                                                                                        <button style={{ padding: "12%", borderRdius: "8px", backgroundColor: "white", color: "red" }}>受け入れました</button>
                                                                                                    )
                                                                                                } else {
                                                                                                    return (
                                                                                                        <button style={{ padding: "", width: '100px', backgroundColor: "#7ea9e6", borderColor: "#6290d1", height: '40px', borderRadius: '5px', color: '#fff', boxShadow: "#ffffff4d 0px 1px 0px 0px inset" }}>購入に進む</button>
                                                                                                        // <button id="res_entry" onClick={() => this.Accept(group.request_id, group.seller_id)} style={{ padding: "", width: '100px', backgroundColor: "#7ea9e6", borderColor: "#6290d1", height: '40px', borderRadius: '5px', color: '#fff', boxShadow: "#ffffff4d 0px 1px 0px 0px inset" }}>受け入れる</button>
                                                                                                    )
                                                                                                }
                                                                                            })()}
                                                                                            {/* <button style={{ padding: "", width: '100px', backgroundColor: "#7ea9e6", borderColor: "#6290d1", height: '40px', borderRadius: '5px', color: '#fff', boxShadow: "#ffffff4d 0px 1px 0px 0px inset" }}>購入に進む</button> */}
                                                                                        </Link>
                                                                                    )
                                                                                }
                                                                            })()}

                                                                        </div>
                                                                    </div>
                                                                    <hr />
                                                                </div>
                                                            )}
                                                        </div>
                                                    )
                                                }
                                            })()}
                                        </div>
                                        &nbsp;
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            );
        }
        } else {
            return (
                <div className="container-fluid">
                    <div className="container">
                        <div className="" style={{ height: '380px' }}></div>
                        <div className="text-center mt-3">
                            <Spinner color="primary" size="150" />
                        </div>
                    </div>
                </div>
            )
        }
    }
}

// const mapStateToProps = (state) => ({
//     buyerLogin: state.buyerLogin,
// });

// BuyerLogin = connect(mapStateToProps, { buyerLogin })(BuyerLogin);

export { RequestDetailsBuyerEstimation };

